import type { MonthlyBill, SubscriptionStanding } from "@dentacore/shared-types";

import { api } from "./client";

/** Whether the clinic is active, in grace or read-only (STORY-190d). No amount in it. */
export function readStanding(signal?: AbortSignal): Promise<SubscriptionStanding> {
  return api<SubscriptionStanding>("/clinic/subscription", { signal });
}

export interface ClinicPlan {
  /** Every amount is in this one platform currency (BL-D3). */
  currency: string;
  branchCount: number;
  bill: MonthlyBill;
}

/** The clinic's plan and monthly price, read-only. Admin only (BL-D7). */
export function readPlan(signal?: AbortSignal): Promise<ClinicPlan> {
  return api<ClinicPlan>("/clinic/plan", { signal });
}
